import styled from "styled-components";
import { useRef, useEffect } from "react";
import { useRecoilState } from "recoil";
import { useParams } from "react-router-dom";
import {
  MDBCard,
  MDBCardHeader,
  MDBCardTitle,
  MDBCardBody,
} from "mdb-react-ui-kit";
import { useTranslation } from "react-i18next";
import { Row, Col } from "../App.styles";
import { TagRow, TagListWrapper, Tag } from "./Library.styles";
import { Pagination, TagList, RowInfo } from "../common";
import { SearchAndAddModal } from "./modals";
import {
  pageState,
  pageSizeState,
  termsState,
  useAutocompleteQuery,
  useLibraryQuery,
  useLibraryFetchingQuery,
  useLibraryPagesQuery,
} from "./Library.state";
import LibraryChallenge from "./LibraryChallenge";

const SampleTag = styled(Tag)`
  cursor: pointer;
`;

const CardRow = styled(Row)`
  margin-bottom: 2rem;
`;

const LibraryForm = () => {
  const { t } = useTranslation();
  const { game_id } = useParams();
  const seed = useRef(0);
  const autocomplete = useAutocompleteQuery(game_id);
  const [terms, setTerms] = useRecoilState(termsState);
  const sampleTerms = ["Puzzle", "Funny", "Video", "Photo"].map(term => t(term));
  const library = useLibraryQuery();
  const pages = useLibraryPagesQuery();
  const [page, setPage] = useRecoilState(pageState);
  const [pageSize, setPageSize] = useRecoilState(pageSizeState);
  const isFetching = useLibraryFetchingQuery();

  const addTerm = (term) => {
    setPage(1);
    setTerms([...terms, term]);
  };

  const removeTerm = (term) => {
    setPage(1);
    setTerms(terms.filter((t) => t !== term));
  };

  const toggleTerm = (term) => {
    if (terms.includes(term)) {
      removeTerm(term);
    } else {
      addTerm(term);
    }
  };

  useEffect(() => (seed.current = Math.random()), []);

  return (
    <>
      <CardRow>
        <Col className="col--stretch">
          <MDBCard className="flex-grow-1">
            <MDBCardHeader>
              <MDBCardTitle>{t('Premium Library')}</MDBCardTitle>
            </MDBCardHeader>
            <MDBCardBody>
              <TagRow>
                <Col size="12" md="6">
                  <p>
                    <strong>{t('Search using tags')}</strong> {t(`applied by our curators and
                    with just one tap add them to your game.`)}
                  </p>
                </Col>
                <Col size="12" md="6">
                  <TagListWrapper>
                    {sampleTerms.map((term) => (
                      <SampleTag key={term} onClick={() => toggleTerm(term)}>
                        {term}
                      </SampleTag>
                    ))}
                  </TagListWrapper>
                </Col>
              </TagRow>
              <RowInfo help={<SearchAndAddModal />} colClassName="tag-col">
                  {
                    autocomplete
                      ? (
                        <TagList
                          value={terms}
                          onAdd={addTerm}
                          onRemove={removeTerm}
                          options={autocomplete}
                        />
                      )
                      : null
                  }
              </RowInfo>
              {library.map(({ id }) => (
                <Row key={id}>
                  <LibraryChallenge id={id} />
                </Row>
              ))}
              <Row>
                <Pagination
                  loading={isFetching}
                  page={page}
                  pageSize={pageSize}
                  pages={pages}
                  setPage={setPage}
                  setPageSize={setPageSize}
                />
              </Row>
            </MDBCardBody>
          </MDBCard>
        </Col>
      </CardRow>
    </>
  );
};

export default LibraryForm;
